module.exports = __webpack_public_path__ + "static/media/AboutUs.3b5c56a7.svg";